import React, {useState, useEffect} from 'react';
import {
  Collapse,
  Row,
  Col,
  Button,
  Tooltip
} from "antd";
import {
  MinusOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { useParams, useNavigate, useLocation } from "react-router-dom";

import {openNotification, progressIndicatorEnum, InvalidPage, ProgressControl} from "@seims/shared";
import PersonalInformation from './PersonalInformationView';
import Qualification from './QualificationView';
import SupportingDocument from './SupportingDocumentView';
import api from "../../services/nysService";
import util from "../../utils/functions/custom";
import { Messages, Notify } from '../../services/custom/Messages';
import { clearToken } from "../../security/AppSecurity";
import { recordError } from '../../utils/logService';

const { Panel } = Collapse;

const ViewCandidate = () => {
  
  const {key} = useParams();
  const navigate = useNavigate();
  let path = `/404`;
  const pageView = {
    SUCCESS: 'success',
    ERROR: 'error',
  }

  const [demogrPogress, setdemogrPogress] = useState(progressIndicatorEnum.NOT_STARTED);
  const [qualifProgress, setqualifProgress] = useState(progressIndicatorEnum.NOT_STARTED);
  const [docsProgress, setdocsProgress] = useState(progressIndicatorEnum.NOT_STARTED);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [expanded, setExpanded] = useState(["1", "2", "3"]);
  const [demographics, setDemographics] = useState({});
  const [qualification, setQualification] = useState({});
  const [documents, setDocuments] = useState([]);
  const [readOnly, setReadOnly] = useState(false);
  const [currentView, setCurrentView] = useState();

  useEffect(() => {
    clearToken(true, key);
    getCondidate();
  }, [currentView])

  const handleDemographicProgress = (progressStatus)=> {
    setdemogrPogress(progressStatus)
  }
  
  const handleQualifProgress = (progressStatus)=> {
    setqualifProgress(progressStatus)
  }
  
  const handleDocsProgress = (progressStatus, progress)=> {
    setdocsProgress(progressStatus)
    setUploadProgress(progress);
  }

  const handleSubmit = async ()=> {
    
    let msg;

    try {
      
      const response = await api.submitProfile();
      
      if (response && (response.status == 200 || response.status == 201)) {
        const {data} = response;  
          
          msg = util.parseMessage(Messages.ADD_SUCCESS, "Candidate profile");
          openNotification("Candidate submission", msg, Notify.SUCCESS);
          return;
        }

        // msg = util.parseMessage(Messages.ADD_FAILURE, "Candidate profile");
        // openNotification("Candidate submission", msg, Notify.ERROR);
    }
    catch(error) {
      
      msg = util.parseMessage(Messages.ADD_FAILURE, "Candidate profile");
      openNotification("Candidate submission", msg, Notify.ERROR);
      // console.log("ERROR", error);
      recordError(error);
    }
  }

  const getCondidate = async () => {
    let msg;
    try {
      
      // const {key} = params;
      const response = await api.updateLinkDetails(key);
      if (response && response.status == 200) {
        setCurrentView(pageView.SUCCESS);

        const {data} = response;  
        setReadOnly(data.readOnly);
        if (data.demographics != undefined) setDemographics(data.demographics);
        if (data.qualifications != undefined) setQualification(data.qualifications);
        if (data.supportingDocuments != undefined) setDocuments(data.supportingDocuments);
      }
      // else if (response && response.status == 400) {
      //   clearToken(true, key);
      // }
    }
    catch(error) {
      msg = util.parseMessage(Messages.INVALID_TOKEN_EXPIRES, "Candidate profile");
      openNotification("Candidate Profile Viewing", msg, Notify.ERROR);
      // navigate(path);
      setCurrentView(pageView.ERROR);
      // console.log("ERROR", error);
      recordError(error);
    }
  }

  const toolTipMessage = !demogrPogress || !qualifProgress || uploadProgress < 100 ? "Disabled because of incomplete profile" : "You may submit your profile";

  return (
    <>
    {currentView === pageView.SUCCESS && (
     <>
      {false && <ProgressControl
        demogrPogress={demogrPogress}
        qualifProgress={qualifProgress}
        docsProgress={docsProgress}
        uploadProgress={uploadProgress}
      />}
      <Collapse
        defaultActiveKey={expanded}
        expandIcon={({ isActive }) =>
          isActive ? <MinusOutlined /> : <PlusOutlined />
        }
        expandIconPosition="end"
      >
        <Panel header="Personal Information" key="1" className="personal-info-background">
          <PersonalInformation
            onProgressUpdate={handleDemographicProgress}
            data={demographics}
            readOnly={readOnly}
          />
        </Panel>
        <Panel header="Qualifications" key="2">
          <Qualification
            onProgressUpdate={handleQualifProgress}
            data={qualification}
            readOnly={readOnly}
          />
        </Panel>
        <Panel header="Supporting Documents" key="3">
          <SupportingDocument
            onProgressUpdate={handleDocsProgress}
            data={documents}
            readOnly={readOnly}
          />
        </Panel>
      </Collapse>
      <br></br><br/>
     </>
    )}
    {currentView === pageView.ERROR && (
      <InvalidPage subTitle="Sorry, unauthorised, invalid or expired token." />
    )}
    </>
  );
}

export default ViewCandidate;